import { render, staticRenderFns } from "./ergonomic-evaluation.page.vue?vue&type=template&id=6a9486f3"
import script from "./ergonomic-evaluation.page.vue?vue&type=script&lang=js"
export * from "./ergonomic-evaluation.page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports